var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVagifting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 3v8m0-8H4.232a.973.973 0 0 1-.694-.293 1.01 1.01 0 0 1 0-1.414A.973.973 0 0 1 4.232 1C5.607 1 6 3 6 3Zm0 0h1.768c.26 0 .51-.105.694-.293a1.01 1.01 0 0 0 0-1.414A.973.973 0 0 0 7.768 1C6.393 1 6 3 6 3Zm4 2.5v3.9c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C9.24 11 8.96 11 8.4 11H3.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2 10.24 2 9.96 2 9.4V5.5M1 3.8v.9c0 .28 0 .42.054.527a.5.5 0 0 0 .219.218c.107.055.247.055.527.055h8.4c.28 0 .42 0 .527-.054a.5.5 0 0 0 .218-.219C11 5.12 11 4.98 11 4.7v-.9c0-.28 0-.42-.055-.527a.5.5 0 0 0-.218-.219C10.62 3 10.48 3 10.2 3H1.8c-.28 0-.42 0-.527.054a.5.5 0 0 0-.218.219C1 3.38 1 3.52 1 3.8Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVagifting);
export default __webpack_public_path__ + "static/media/vagifting.06c98763d773f1e4f9743d9b10250554.svg";
export { ForwardRef as ReactComponent };